import { createModelSegment } from 'client/data/luckdragon/segment';

export const FeatureFlagModel = createModelSegment('featureFlags', []);
